import { render, staticRenderFns } from "./listGallery.vue?vue&type=template&id=92d226fa&scoped=true"
import script from "./listGallery.vue?vue&type=script&lang=js"
export * from "./listGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d226fa",
  null
  
)

export default component.exports